<script>
    export let options = [];
    export let display_func = (a) => a;
    export let index = 0;
    export let value;

    $: {
        value = options[index];
        console.log(value);
    }
</script>

<select class="dropdown" bind:value={index}>
    {#each options as option, i}
        <option class="option" value={i}>{display_func(option)}</option>
    {/each}
</select>

<style>
    select {
        padding: 10px;
        size: 10px;
        font-family: "Poppins";
        font-weight: bold;
        color: #425373;
    }

</style>
